import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs))

/**
 * Extracts the conversation ID from a `/chat/[id]` pathname.
 * Returns `undefined` when the path doesn't match.
 */
export const extractConversationIdFromPath = (pathname: string | null): string | undefined => {
    if (!pathname) return undefined
    const match = pathname.match(/^\/chat\/([^/]+)$/)
    return match?.[1]
}
